import { forwardRef } from "react"

export const Input = forwardRef(function Input({ className = "", type = "text", ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      className={`
        flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm
        text-foreground placeholder:text-muted-foreground
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
        focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50
        ${className}
      `}
      {...props}
    />
  )
})

export function SearchInput({ className = "", ...props }) {
  return (
    <div className="relative">
      <svg
        className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
      <Input className={`pl-10 ${className}`} {...props} />
    </div>
  )
}
